import { combineReducers } from 'redux';
import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // defaults to localStorage for web
import thunk from 'redux-thunk';
import logger from 'redux-logger'


import authReducer from './authSlice'
import profileReducer from './profileSlice';
import shopReducer from './shopSlice';
import billReducer from './billSlice';
import deviceReducer from './deviceSlice';
import shiftReducer from './shiftSlice';

import inboundReducer from './inboundSlice';
import checkInReducer from './checkInSlice';
import memberReducer from './memberSlice';
import requisitionReducer from './requisitionSlice';

  const rootPersistConfig = {
      key: 'root',
      storage,
      whitelist:[]
  }
  const authPersistConfig = {
    key: 'auth',
    storage,
    whitelist: ['currentUser','currentShopId','franchiseDisplay',]
  };
  const profilePersistConfig = {
    key: 'profile',
    storage,
    whitelist: ['profile']
  };
  const shopPersistConfig = {
    key: 'shop',
    storage,
    whitelist: ['shop','premiumEnable','memberEnable','staffEnable','warehouseEnable','deliveryEnable']
  };
  const devicePersistConfig = {
    key: 'device',
    storage,
    whitelist: ['language']
  };


  const rootReducer = combineReducers({
    auth: persistReducer(authPersistConfig, authReducer),
    profile:persistReducer(profilePersistConfig, profileReducer),
    shop:persistReducer(shopPersistConfig, shopReducer),
    bill:billReducer,
    device:persistReducer(devicePersistConfig, deviceReducer),
    shift:shiftReducer,
    inbound:inboundReducer,
    checkIn:checkInReducer,
    member:memberReducer,
    requisition:requisitionReducer,

  })
  const persistedReducer = persistReducer(rootPersistConfig, rootReducer)

  export const store = configureStore({
    reducer: persistedReducer,
    middleware: [thunk, logger],
  })
export const persistor = persistStore(store)